import React, { Component } from 'react';

class FAQGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCategory: 'all'
    };
  }

  render() {
    const { data } = this.props;
    const { activeCategory } = this.state;

    // Get unique categories (most FAQ items don't have categories, so we'll just show all)
    const categories = ['all'];

    // Filter items based on active category
    const filteredItems = data.items || [];

    return (
      <section className="p-80px-tb">
        <div className="container">
          <div className="row">
            <div className="col-sm-8 offset-sm-2">
              <div className="section-title text-center m-50px-b">
                <h2>{data.pageTitle}</h2>
                {data.pageSubtitle && <p className="lead text-muted">{data.pageSubtitle}</p>}
              </div>
            </div>
          </div>

          {/* Category Filter */}
          <div className="row m-30px-b">
            <div className="col-md-12 text-center">
              <div className="btn-group" role="group">
                {categories.map((category, i) => (
                  <button
                    key={i}
                    type="button"
                    className={`btn ${activeCategory === category ? 'btn-primary' : 'btn-outline-primary'} m-5px`}
                    onClick={() => this.setState({ activeCategory: category })}
                  >
                    {category === 'all' ? 'すべて' : category}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* FAQ Items Grid */}
          <div className="row">
            {filteredItems.map((item, i) => {
              return (
                <div key={i} className="col-lg-6 m-20px-b">
                  <div className="service-box p-30px h-100">
                    <div className="faq-question m-15px-b">
                      <h5 className="font-weight-bold">
                        <i className="icofont-question-circle text-primary m-10px-r"></i>
                        {item.question}
                      </h5>
                    </div>
                    <div className="faq-answer">
                      <p className="text-muted">{item.answer}</p>
                    </div>
                    {item.category && (
                      <div className="faq-category m-10px-t">
                        <span className="badge badge-light">{item.category}</span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Contact CTA */}
          {data.ctaText && (
            <div className="row m-50px-t">
              <div className="col-md-12 text-center">
                <div className="p-40px bg-light rounded">
                  <h4 className="m-20px-b">{data.ctaText}</h4>
                  <a href="#contact" className="btn btn-primary btn-filled animated-btn">
                    お問い合わせ
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default FAQGrid;